import removeSpaces from './text/removeSpaces';

const compareRoles = (a?: string, b?: string): boolean =>
  removeSpaces(a)?.toLocaleLowerCase() === removeSpaces(b)?.toLocaleLowerCase();

export default compareRoles;
